/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// src/components/ui/input.jsx
import * as React from "react";

export function Input({ className = "", value, ...props }) {
  // Ensure value is never null or undefined to prevent controlled/uncontrolled switch
  const safeValue = value ?? '';
  
  return (
    <input
      className={
        [
          "w-full",
          "rounded-md",
          "border",
          "border-borderDefault",
          "bg-backgroundInput",
          "text-textPrimary",
          "placeholder-textSecondary",
          "focus:outline-none",
          "focus:ring-2",
          "focus:ring-primary",
          "focus:border-primary",
          className,
        ].join(" ")
      }
      style={{
        paddingLeft: 'var(--input-padding-x)',
        paddingRight: 'var(--input-padding-x)',
        paddingTop: 'var(--input-padding-y)',
        paddingBottom: 'var(--input-padding-y)',
        fontSize: 'var(--input-font-size)',
      }}
      value={safeValue}
      {...props}
    />
  );
}
